export const generateRandomUUID = () => {
  return Math.random().toString(16).substring(2, 10);
};
